import favoriteHeartFactory from '@finn-no/favorite-heart-component';
import { useConfig } from 'shared/config/ConfigContext';

type FavoriteButtonVariant = 'heart' | 'heart-blue' | 'heart-on-image' | 'button' | 'button-with-text' | 'button-on-image';

type FavoriteButtonProps = {
    itemId: number | string;
    variant: FavoriteButtonVariant;
    itemType: 'Ad' | 'Hotel';
    wrapperClassName?: string;
    buttonClass?: string;
    loginId?: string | null;
    isMobile?: boolean;
};

export const FavoriteButton = ({
    itemId,
    variant,
    buttonClass,
    wrapperClassName,
    itemType,
    loginId,
    isMobile = false,
}: FavoriteButtonProps) => {
    const { favouriteBaseUri } = useConfig();

    const FavoriteComponent = favoriteHeartFactory({ userId: loginId ?? undefined, baseUri: favouriteBaseUri });

    const numericItemId = typeof itemId === 'string' ? Number(itemId) : itemId;

    return (
        <div className={wrapperClassName} data-testid="favoriteButton">
            <FavoriteComponent itemType={itemType} variant={variant} itemId={numericItemId} buttonClass={buttonClass} isMobile={isMobile} />
        </div>
    );
};
